module.exports = __webpack_public_path__ + "static/img/1_4_2.9bcd6cd5.jpg";